import { keys } from "@/utils/tsUtils/keys";
import { IMGIX_HOST } from "./convertToImgixUrl.constants";

/**
 * hostShouldBeImgix` corresponds to base image host URLs pointing to
 * Newsela's static file storage (e.g. S3) that can be safely replaced with
 * Newsela's imgix server host. The SRE team maintains the imgix server's
 * ability to serve image file contents from Newsela's static file storage.
 */
const hostShouldBeImgix = new Set([
  "media.newsela.com",
  "newsela-media.s3.amazonaws.com",
  "prod-newsela-media.s3.amazonaws.com",
]);

/**
 * `convertToImgixUrl` is very possibly a temporary solution. Lyceum is
 * currently sourcing content from static JSON manually queried from
 * Alexandria directly. In the future, when Lyceum sources content from a more
 * permanent / central backend, image URLs may come with the imgix host already
 * present. If that happens, we will no longer need this utility in Lyceum.
 */
const convertToImgixUrl = (imageUrlString: string, params = {}) => {
  if (!imageUrlString) return;
  const imageUrl = new URL(imageUrlString);
  const paramKeys = keys(params);
  for (const key of paramKeys) {
    imageUrl.searchParams.set(key, params[key]);
  }
  if (hostShouldBeImgix.has(imageUrl.host) && IMGIX_HOST) {
    imageUrl.host = IMGIX_HOST;
  }
  return decodeURIComponent(imageUrl.toString());
};

export default convertToImgixUrl;
